import React from 'react'
import styled from 'styled-components'
import doorImg from './opened-door.png'

const Wrapper = styled.div`
  color: #383838;
  font-weight: bold;
  font-size: 3.5rem;
  margin-right: 3rem;

  img {
    height: 4rem;
    margin-right: 1.3rem;
  }
`

interface IProps {
  className?: string
  doorNumber: string
}

const Door = ({ className, doorNumber }: IProps) => (
  <Wrapper className={className}>
    <img src={doorImg} alt="opened door"/>
    {doorNumber}
  </Wrapper>
)

export default Door
